import { useQuery } from '@tanstack/react-query';

import { Badge, Card, EmptyState, Spinner } from '../../components/ui';
import { api } from '../../lib/api';
import { formatCents, formatDate } from '../../lib/formatters';

interface Pay {
  id: string;
  amount: number;
  currency: string;
  type: string;
  status: string;
  createdAt: string;
}

export function MyPayments() {
  const { data, isLoading } = useQuery<{ items: Pay[] }>({
    queryKey: ['my-payments'],
    queryFn: async () => (await api.get('/public/me/payments')).data,
  });

  if (isLoading) return <Spinner />;

  return (
    <div className="space-y-4">
      <h1 className="font-display text-3xl">My payments</h1>
      {(data?.items ?? []).length === 0 ? (
        <EmptyState title="No payments yet" />
      ) : (
        <Card>
          <ul className="divide-y divide-cream-300">
            {data!.items.map((p) => (
              <li key={p.id} className="px-5 py-3 flex items-center justify-between">
                <div>
                  <div className="font-medium">{p.type}</div>
                  <div className="text-sm text-ink-muted">{formatDate(p.createdAt)}</div>
                </div>
                <div className="flex items-center gap-3">
                  <Badge variant={p.status === 'PAID' ? 'success' : 'default'}>{p.status}</Badge>
                  <span className="tabular-nums font-medium">{formatCents(p.amount, p.currency)}</span>
                </div>
              </li>
            ))}
          </ul>
        </Card>
      )}
    </div>
  );
}
